<template>
  <div class="relative w-full">
    <slides @next="next" @skip="next" @leave="leave" />
  </div>
</template>

<script>
import page from '@/mixins/page';
import leave from '@/mixins/leave';
import audioPlayer from '@/mixins/audio-player';

import Slides from '@/components/MobileScan2/Tutorial/Slides.vue';

export default {
  name: 'Tutorial',
  mixins: [page, leave, audioPlayer],
  components: {
    Slides,
  },
  mounted() {
  },
  data: () => ({
    currentPageNo: 1,
  }),
  methods: {
    next() {
      this.stopAudio();
      this.$events.goto('MobileScan2/CheckList');
    },
  },
};
</script>

<style scoped></style>
